import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tray component.
 *
 * This is the actual tray that the dropdown menu opens up. It is where the
 * content of the dropdown is rendered.
 *
 * @class Tray
 * @public
 */
class Tray extends NamespaceConsumer {
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  render() {
    const props = this.props;
    const renderChildren = props.open || props.renderClosed;

    return (
      <div className={ this.classNames(props.className,
        this.namespace('tray-dropdown', this.isBrowser && 'loaded')) }
      ref={ r => { this.wrapper = r; } }>
        { renderChildren && <div className={ this.namespace('tray-content') }>
          { props.children }
        </div> }
      </div>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Tray.propTypes = {
  ...NamespaceShape,
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  renderClosed: PropTypes.bool
};

export default withNamespace(Tray);
